/**
 * Browser Notifications utility
 * Handles requesting permission and showing browser notifications
 */

let permissionGranted = false;

/**
 * Request notification permission from the user
 */
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    permissionGranted = true;
    return true;
  }

  if (Notification.permission === 'denied') {
    console.warn('Notification permission denied');
    return false;
  }

  // Request permission
  const permission = await Notification.requestPermission();
  permissionGranted = permission === 'granted';
  return permissionGranted;
};

/**
 * Show a browser notification
 */
export const showBrowserNotification = (title, options = {}) => {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications');
    return null;
  }

  if (Notification.permission !== 'granted') {
    console.warn('Notification permission not granted');
    return null;
  }

  const defaultOptions = {
    icon: '/logo192.png', // Default icon
    badge: '/logo192.png',
    tag: 'st-cael-notification',
    requireInteraction: false,
    ...options,
  };

  const notification = new Notification(title, defaultOptions);

  // Auto-close after 5 seconds if not requiring interaction
  if (!defaultOptions.requireInteraction) {
    setTimeout(() => {
      notification.close();
    }, 5000);
  }

  // Handle click
  notification.onclick = (event) => {
    event.preventDefault();
    window.focus();

    if (options.onClick) {
      options.onClick();
    } else if (options.link && typeof window.__notificationNavigate === 'function') {
      window.__notificationNavigate(options.link, options.data);
    } else if (options.link) {
      window.location.href = options.link;
    }

    notification.close();
  };

  return notification;
};

/**
 * Check if notifications are supported
 */
export const isNotificationSupported = () => {
  return 'Notification' in window;
};

/**
 * Check if permission is granted
 */
export const hasNotificationPermission = () => {
  return 'Notification' in window && Notification.permission === 'granted';
};

/**
 * Get current permission status
 */
export const getNotificationPermission = () => {
  if (!('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

